import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: {
        Heading: () => <>Questions?</>,
        SubHeading: () => (
            <>
                If you have any other questions other than what we’ve listed
                here, please reach out to Brian or Lin any time
            </>
        ),
    },
    [LANGUAGE.ZH]: {
        Heading: () => <>常见问题</>,
        SubHeading: () => (
            <>
                如果您有一些其他问题，请联系美丽善良大方的新娘子毛琳
            </>
        ),
    },
}
